/* task02-cdn-bump 1788046193954 */
/**
 * Bee Hive shared live commerce normalizer (storefront / generated pages).
 * Contract mirrors bee-hive-api/src/lib/partnerProductCommerce.js.
 * Uses public /products/{handle}.js — never Admin GraphQL in the browser.
 */
(function (global) {
  'use strict';

  var CONTRACT = 'bee_hive_partner_product_commerce_v1';

  function trim(value) {
    return String(value == null ? '' : value).trim();
  }

  function absUrl(url) {
    var raw = trim(url);
    if (!raw) return '';
    if (raw.indexOf('//') === 0) return 'https:' + raw;
    return raw;
  }

  function centsToDecimal(cents) {
    if (cents == null || !isFinite(Number(cents))) return null;
    var n = Math.trunc(Number(cents));
    var sign = n < 0 ? '-' : '';
    var abs = Math.abs(n);
    var whole = Math.floor(abs / 100);
    var frac = String(abs % 100);
    if (frac.length < 2) frac = '0' + frac;
    return sign + whole + '.' + frac;
  }

  function buildFromStorefrontProduct(selection, product) {
    selection = selection || {};
    var selectedVariantId = trim(selection.variant_id || selection.selected_variant_id || '');
    var handle = trim(selection.handle || selection.product_handle || (product && product.handle) || '');
    var base = {
      contract: CONTRACT,
      shopify_product_id: trim(selection.shopify_product_id || selection.id || (product && product.id) || ''),
      product_handle: handle,
      handle: handle,
      selected_variant_id: selectedVariantId,
      variant_id: selectedVariantId,
      selected_variant_label: trim(selection.variant_label || selection.selected_variant_label || ''),
      variant_label: trim(selection.variant_label || selection.selected_variant_label || ''),
      title: trim((product && product.title) || selection.title || ''),
      vendor: trim((product && product.vendor) || ''),
      product_image_url: '',
      product_image_alt: '',
      variant_image_url: '',
      variant_image_alt: '',
      display_image_url: '',
      display_image_alt: '',
      price: null,
      price_cents: null,
      compare_at_price: null,
      compare_at_price_cents: null,
      available: false,
      sold_out: false,
      quantity_min: 1,
      quantity_increment: 1,
      product_exists: false,
      product_published: false,
      variant_exists: false,
      variant_belongs_to_product: false,
      needs_variant_selection: false,
      variant_attention: '',
      commerce_ready: false,
      commerce_block_reason: '',
      productgids_enabled: Boolean(selection.productgids_enabled),
      productgids_has_intro: Boolean(selection.productgids_has_intro),
      productgids_has_directions: Boolean(selection.productgids_has_directions),
      productgids_has_ingredients: Boolean(selection.productgids_has_ingredients),
      productgids_has_composition: Boolean(selection.productgids_has_composition),
      productgids_has_warnings: Boolean(selection.productgids_has_warnings),
      productgids_has_faq: Boolean(selection.productgids_has_faq),
      short_info_available: Boolean(selection.short_info_available),
      short_info_source: trim(selection.short_info_source || ''),
      source: trim(selection.source || 'storefront_js'),
    };

    if (!product) {
      base.commerce_block_reason = 'missing_product';
      base.variant_attention = selectedVariantId ? 'missing_variant' : '';
      base.display_image_url = absUrl(selection.display_image_url || selection.variant_image_url || selection.image_url);
      base.display_image_alt = trim(selection.display_image_alt || selection.title || '');
      return base;
    }

    base.product_exists = true;
    base.product_published = true;
    base.shopify_product_id = String(product.id || base.shopify_product_id);
    base.title = trim(product.title || base.title);
    base.vendor = trim(product.vendor || '');
    base.product_handle = trim(product.handle || handle);
    base.handle = base.product_handle;
    base.product_image_url = absUrl(product.featured_image);
    base.product_image_alt = base.title;

    var variants = Array.isArray(product.variants) ? product.variants : [];
    var match = null;
    for (var i = 0; i < variants.length; i += 1) {
      if (String(variants[i].id) === String(selectedVariantId)) {
        match = variants[i];
        break;
      }
    }

    if (!selectedVariantId) {
      base.needs_variant_selection = variants.length > 1;
      base.variant_attention = variants.length > 1 ? 'variant_required' : '';
      base.commerce_block_reason = variants.length > 1 ? 'variant_required' : 'missing_selected_variant';
    } else if (!match) {
      base.variant_exists = false;
      base.variant_belongs_to_product = false;
      base.needs_variant_selection = true;
      base.variant_attention = 'missing_variant';
      base.commerce_block_reason = 'missing_selected_variant';
    } else {
      base.variant_exists = true;
      base.variant_belongs_to_product = true;
      base.selected_variant_label = trim(match.title || match.public_title || base.selected_variant_label);
      base.variant_label = base.selected_variant_label;
      base.available = Boolean(match.available);
      base.sold_out = !base.available;
      // Never coerce missing/invalid prices to 0 — only accept finite numeric cents.
      base.price_cents = (function (raw) {
        if (raw == null || raw === '') return null;
        if (typeof raw === 'boolean') return null;
        var n = Number(raw);
        if (!isFinite(n)) return null;
        if (n > 0 && n < 1000 && String(raw).indexOf('.') !== -1) {
          return Math.round(n * 100);
        }
        return Math.trunc(n);
      })(match.price);
      base.compare_at_price_cents = (function (raw) {
        if (raw == null || raw === '') return null;
        if (typeof raw === 'boolean') return null;
        var n = Number(raw);
        return isFinite(n) ? Math.trunc(n) : null;
      })(match.compare_at_price);
      base.price = centsToDecimal(base.price_cents);
      base.compare_at_price = centsToDecimal(base.compare_at_price_cents);
      var rule = match.quantity_rule || {};
      base.quantity_min = Number(rule.min) > 0 ? Number(rule.min) : 1;
      base.quantity_increment = Number(rule.increment) > 0 ? Number(rule.increment) : 1;
      var vSrc =
        (match.featured_image && match.featured_image.src) ||
        (match.featured_media &&
          match.featured_media.preview_image &&
          match.featured_media.preview_image.src) ||
        '';
      if (vSrc) {
        base.variant_image_url = absUrl(vSrc);
        base.variant_image_alt = trim((match.featured_image && match.featured_image.alt) || '') || base.title;
      }
    }

    base.display_image_url = base.variant_image_url || base.product_image_url;
    base.display_image_alt = base.variant_image_url ? base.variant_image_alt || base.title : base.product_image_alt;

    if (!base.short_info_available && trim(product.description || '')) {
      base.short_info_available = true;
      base.short_info_source = 'product_description';
    }

    if (!base.variant_exists || !base.variant_belongs_to_product) {
      base.commerce_ready = false;
    } else if (base.price_cents == null) {
      base.commerce_ready = false;
      base.commerce_block_reason = 'price_unavailable';
    } else {
      base.commerce_ready = true;
      base.commerce_block_reason = base.sold_out ? 'sold_out' : '';
    }

    return base;
  }

  function fetchStorefrontProduct(handle) {
    var h = trim(handle);
    if (!h) return Promise.resolve(null);
    return fetch('/products/' + encodeURIComponent(h) + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    }).then(function (res) {
      if (!res.ok) return null;
      return res.json();
    }).catch(function () {
      return null;
    });
  }

  function hydrateSelections(selections) {
    var list = Array.isArray(selections) ? selections : [];
    var CONCURRENCY = 4;

    function hydrateOne(selection) {
      var handle = trim(selection.handle || selection.product_handle || '');
      if (selection.commerce_ready && selection.price_cents != null && selection.variant_exists) {
        return Promise.resolve(
          Object.assign({}, selection, {
            commerce: selection.commerce || selection,
            detail: selection.detail || null,
          })
        );
      }
      return fetchStorefrontProduct(handle).then(function (product) {
        var commerce = buildFromStorefrontProduct(selection, product);
        return Object.assign({}, selection, commerce, {
          commerce: commerce,
          detail: selection.detail || null,
          partner_note:
            selection.partner_note ||
            (selection.detail && selection.detail.partner_note) ||
            '',
        });
      });
    }

    // Concurrent fallback hydration (no serial 700ms stagger). Server-ready
    // rows resolve immediately; only missing commerce hits /products/{handle}.js.
    var results = new Array(list.length);
    var index = 0;

    function worker() {
      if (index >= list.length) return Promise.resolve();
      var i = index;
      index += 1;
      return hydrateOne(list[i]).then(function (item) {
        results[i] = item;
        return worker();
      });
    }

    var workers = [];
    for (var w = 0; w < Math.min(CONCURRENCY, list.length); w += 1) {
      workers.push(worker());
    }
    return Promise.all(workers).then(function () {
      return results;
    });
  }

  global.BeeHivePartnerCommerce = {
    CONTRACT: CONTRACT,
    buildFromStorefrontProduct: buildFromStorefrontProduct,
    fetchStorefrontProduct: fetchStorefrontProduct,
    hydrateSelections: hydrateSelections,
  };
})(typeof window !== 'undefined' ? window : globalThis);
